import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { PortalAutoQuoteNode } from '@app/services/api/api.types';

@Injectable({ providedIn: 'root' })
export class PortalAutoQuoteContextService {
  autoQuoteSubject = new BehaviorSubject<PortalAutoQuoteNode | null>(null);

  getAutoQuote(): PortalAutoQuoteNode | null {
    return this.autoQuoteSubject.value;
  }

  getAutoQuote$() {
    return this.autoQuoteSubject.asObservable();
  }

  setAutoQuote(quote: PortalAutoQuoteNode) {
    this.autoQuoteSubject.next(quote);
  }

  clear() {
    this.autoQuoteSubject.next(null);
  }
}
